import Cookie from 'js-cookie';
import axios from 'axios';

export default class VoteService {
    constructor(private apiUrl: string, private cookieDomain: string = '.hvg.hu') { }

    private voteAdCookieName: string = 'VoteAd';

    public async save(voteId: string, optionId: string) {
        this.saveToCookie(voteId, optionId);
        var result = await axios.get(`${this.apiUrl}questionnaire/${voteId}/increment/${optionId}`, {
            params: {
                rnd: Math.random() // mivel get végpont és cache-el a böngésző
            }
        });

        return this.parseData(result.data);
    };

    public async load(voteId: string) {
        console.log(this.cookieDomain);

        var data = (await axios.get(`${this.apiUrl}questionnaire/${voteId}/result`)).data;

        return {
            vote: {
                id: data.vote.id,
                title: data.vote.title,
                description: data.vote.description
            },
            items: this.parseData(data),
        };
    }

    private saveToCookie(voteId: string, optionId: string) {
        var cookie = this.getAlreadyVoted();
        if (!cookie[voteId]) {
            cookie[voteId] = optionId;
        }
        Cookie.set(this.voteAdCookieName, JSON.stringify(cookie), { expires: 365, domain: this.cookieDomain });
    }

    private getAlreadyVoted() {
        var cookie;
        try {
            cookie = Cookie.get(this.voteAdCookieName);
            if (cookie) {
                cookie = JSON.parse(cookie);
            } else {
                cookie = {};
            }
        } catch (e) {
            cookie = {};
        }

        return cookie;
    }

    public isAlreadyVotedFor(voteId: string) {
        var alreadyVoted = this.getAlreadyVoted();

        return !!alreadyVoted[voteId];
    }

    private parseData(data: any) {
        return data.voteItems.map((vi: any, i: any) => {
            return {
                id: data.vote.voteItems[i].id,
                caption: vi.caption,
                percent: vi.percent,
                isSegment: vi.isSegment,
                segmentId: vi.segmentId,
                isLongest: vi.isLongest
            };
        });
    }
}

